import momentLib from "moment";

const moment = (date) => {
  return <span>{momentLib(date).fromNow()}</span>;
};
export default moment;
